import MasterDataRepository from '@/js/repositories/masterDataRepository';

export default {
  async addMasterData(data, tableName, key, localKey) {
    return MasterDataRepository.addMasterData(data, tableName, key, localKey);
  },
  async getAllPrimaryKeys(tableName) {
    return MasterDataRepository.getAllTableIds(tableName);
  },
  async removeMasterData(data, tableName, key) {
    return MasterDataRepository.removeMasterData(data, tableName, key);
  },
  async multipleDeleteByKey(items, tableName, key) {
    /* for (let i = 0; i < items.length; i += 1) {
      const element = items[i];
      await MasterDataRepository.deleteByProperty(tableName,key, element["Codigo"]);
    } */
    await MasterDataRepository.deleteByProperty(tableName, key, items);
  },
  async getByKey(tableName, key, value) {
    return MasterDataRepository.getByKey(tableName, key, value);
  },
  // COMPLEMENTARY DATA
  async getAllDcs() {
    return MasterDataRepository.getAllDcs();
  },
  async updateDCById(id, updateObj) {
    return MasterDataRepository.updateDCById(id, updateObj);
  },
  async getDCByEntity(entity) {
    return MasterDataRepository.getDCByEntity(entity);
  },
  async addDcs(data) {
    return MasterDataRepository.addDcs(data);
  },
  async deleteDCById(id) {
    return MasterDataRepository.deleteDCById(id);
  },

  // OWNERSHIP TYPES
  getAllOwnershipTypes() {
    return MasterDataRepository.getAllOwnershipTypes();
  },
  updateOwnershipTypeById(id, updateObj) {
    return MasterDataRepository.updateOwnershipTypeById(id, updateObj);
  },
  getOwnershipTypeById(ids) {
    return MasterDataRepository.getOwnershipTypeById(ids);
  },
  addOwnershipTypes(data) {
    return MasterDataRepository.addOwnershipTypes(data);
  },
  deleteOwnershipTypeById(id) {
    return MasterDataRepository.deleteOwnershipTypeById(id);
  },

  // QUALITY PROTOCOLS
  getAllProtocols() {
    return MasterDataRepository.getAllProtocols();
  },
  updateProtocolById(id, updateObj) {
    return MasterDataRepository.updateProtocolById(id, updateObj);
  },
  getProtocolById(ids) {
    return MasterDataRepository.getProtocolById(ids);
  },
  addProtocols(data) {
    return MasterDataRepository.addProtocols(data);
  },
  deleteProtocolById(id) {
    return MasterDataRepository.deleteProtocolById(id);
  },

  // CAMPAIGN
  getAllCampaigns() {
    return MasterDataRepository.getAllCampaigns();
  },
  updateCampaignById(id, updateObj) {
    return MasterDataRepository.updateCampaignById(id, updateObj);
  },
  getCampaignById(ids) {
    return MasterDataRepository.getCampaignById(ids);
  },
  addCampaigns(data) {
    return MasterDataRepository.addCampaigns(data);
  },
  deleteCampaignById(id) {
    return MasterDataRepository.deleteCampaignById(id);
  },

  // VARIETIES
  getAllVarieties() {
    return MasterDataRepository.getAllVarieties();
  },
  updateVarietyById(id, updateObj) {
    return MasterDataRepository.updateVarietyById(id, updateObj);
  },
  getVarietyById(ids) {
    return MasterDataRepository.getVarietyById(ids);
  },
  addVarieties(data) {
    return MasterDataRepository.addVarieties(data);
  },
  deleteVarietyById(id) {
    return MasterDataRepository.deleteVarietyById(id);
  },

  // COUNTRIES
  getAllCountries() {
    return MasterDataRepository.getAllCountries();
  },
  updateCountryById(id, updateObj) {
    return MasterDataRepository.updateCountryById(id, updateObj);
  },
  getCountryById(ids) {
    return MasterDataRepository.getCountryById(ids);
  },
  addCountries(data) {
    return MasterDataRepository.addCountries(data);
  },
  deleteCountryById(id) {
    return MasterDataRepository.deleteCountryById(id);
  },

  // FAMILIES OF VARIETIES
  getAllFamilies() {
    return MasterDataRepository.getAllFamilies();
  },
  updateFamilyById(id, updateObj) {
    return MasterDataRepository.updateFamilyById(id, updateObj);
  },
  getFamilyById(ids) {
    return MasterDataRepository.getFamilyById(ids);
  },
  addFamilies(data) {
    return MasterDataRepository.addFamilies(data);
  },
  deleteFamilyById(id) {
    return MasterDataRepository.deleteFamilyById(id);
  },

  // VAT RATE
  getAllVATRate() {
    return MasterDataRepository.getAllVATRate();
  },
  updateVATRate(id, updateObj) {
    return MasterDataRepository.updateVATRate(id, updateObj);
  },
  getVATRate(ids) {
    return MasterDataRepository.getVATRate(ids);
  },
  addVATRate(data) {
    return MasterDataRepository.addVATRate(data);
  },
  deleteVATRate(id) {
    return MasterDataRepository.deleteVATRate(id);
  },

  // RETENTION
  getAllRetention() {
    return MasterDataRepository.getAllRetention();
  },
  updateRetention(id, updateObj) {
    return MasterDataRepository.updateRetention(id, updateObj);
  },
  getRetention(ids) {
    return MasterDataRepository.getRetention(ids);
  },
  addRetention(data) {
    return MasterDataRepository.addRetention(data);
  },
  deleteRetention(id) {
    return MasterDataRepository.deleteRetention(id);
  },

  // BUSINESS
  getAllBusiness() {
    return MasterDataRepository.getAllBusiness();
  },
  updateBusiness(id, updateObj) {
    return MasterDataRepository.updateBusiness(id, updateObj);
  },
  getBusiness(ids) {
    return MasterDataRepository.getBusiness(ids);
  },
  addBusiness(data) {
    return MasterDataRepository.addBusiness(data);
  },
  deleteBusiness(id) {
    return MasterDataRepository.deleteBusiness(id);
  },

  // WAY TO PAY
  getAllWayToPay() {
    return MasterDataRepository.getAllWayToPay();
  },
  updateWayToPay(id, updateObj) {
    return MasterDataRepository.updateWayToPay(id, updateObj);
  },
  getWayToPay(ids) {
    return MasterDataRepository.getWayToPay(ids);
  },
  addWayToPay(data) {
    return MasterDataRepository.addRetention(data);
  },
  deleteWayToPay(id) {
    return MasterDataRepository.deleteWayToPay(id);
  },

  // Zones
  getAllZones() {
    return MasterDataRepository.getAllZones();
  },
  updateZones(id, updateObj) {
    return MasterDataRepository.updateZones(id, updateObj);
  },
  getZones(ids) {
    return MasterDataRepository.getZones(ids);
  },
  addZones(data) {
    return MasterDataRepository.addZones(data);
  },
  deleteZones(id) {
    return MasterDataRepository.deleteZones(id);
  },
};
